export default "__VITE_ASSET__bd52fe62__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg3__"